export const routesRaporRptbezetting = [
  {
    path: "/rapor_rptbezetting",
    name: "rapor_rptbezetting",
    component: () => import("@/views/mesai/rapor_rptbezetting/index.vue"),
    meta: {
      public: false,
      title: "mesai.Rpt bezetting",
      yetki: { k: [1012702] },
    },
  },
]
